import { render, staticRenderFns } from "./stockUpload.vue?vue&type=template&id=a6f7f8f0&scoped=true"
import script from "./stockUpload.vue?vue&type=script&lang=js"
export * from "./stockUpload.vue?vue&type=script&lang=js"
import style0 from "./stockUpload.vue?vue&type=style&index=0&id=a6f7f8f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f7f8f0",
  null
  
)

export default component.exports